import { render, staticRenderFns } from "./ActivityLogTable.vue?vue&type=template&id=4907d465&scoped=true&"
import script from "./ActivityLogTable.vue?vue&type=script&lang=js&"
export * from "./ActivityLogTable.vue?vue&type=script&lang=js&"
import style0 from "./ActivityLogTable.vue?vue&type=style&index=0&id=4907d465&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4907d465",
  null
  
)

export default component.exports